
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('g',{attrs:{"stroke-width":"1.2"}},[_c('path',{attrs:{"d":"M13.75 18.12v9.38s-6.25.62-6.25-3.75v-5L1.87 15s5.91 1.53 7.5 3.12c1.25 1.25 4.38 0 4.38 0z"}}),_c('circle',{attrs:{"cx":"11.56","cy":"13.44","r":"2.81"}})]),_c('g',{attrs:{"stroke-width":"1.2"}},[_c('path',{attrs:{"d":"M16.87 18.12v9.38s6.25.62 6.25-3.75v-5L28.75 15s-5.91 1.53-7.5 3.12c-1.25 1.25-4.38 0-4.38 0z"}}),_c('circle',{attrs:{"cx":"19.06","cy":"13.44","r":"2.81"}})]),_c('path',{attrs:{"stroke-width":"1.6","d":"M3.75 13.12v-7a3 3 0 013-3h16.5a3 3 0 013 3v7"}})])])
          )
        }
      }
    